import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";
import type {
  ZoteroSettings,
  ZoteroPushResponse,
  ZoteroCollectionsResponse,
} from "@/types/zotero";

export function useZoteroSettings() {
  return useQuery({
    queryKey: ["zotero-settings"],
    queryFn: () =>
      apiClient.get("api/integrations/zotero").json<ZoteroSettings>(),
    retry: false,
  });
}

export function useZoteroPush(conceptId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (paperIds: string[]) =>
      apiClient
        .post(`api/concepts/${conceptId}/zotero/push`, {
          json: { paper_ids: paperIds },
        })
        .json<ZoteroPushResponse>(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["papers", conceptId] });
    },
  });
}

export function useZoteroCollections() {
  return useQuery({
    queryKey: ["zotero-collections"],
    queryFn: () =>
      apiClient
        .get("api/integrations/zotero/collections")
        .json<ZoteroCollectionsResponse>(),
    enabled: false, // manually triggered via refetch()
    retry: false,
  });
}
